<template>
  <div>
    <div class="field m-b-15">
      <label class="label">Password Protected?</label>
      <div class="control">
        <label class="radio">
          <input
            type="radio"
            name="password_protected"
            v-model="email.password_protected"
            :value="true"
            required
          />
          Yes
        </label>
        <label class="radio">
          <input
            type="radio"
            name="password_protected"
            v-model="email.password_protected"
            :value="false"
          />
          No
        </label>
      </div>
      <div v-if="email.password_protected">
        <label class="label">Password</label>
        <div class="control">
          <input
          class="input"
          v-model="email.password"
          type="text"
          placeholder="Enter password here..."
          :required="email.password_protected === true"
        />
      </div>
        <p class="help is-danger">Please communicate to the recipient(s) if the password is updated</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditEmailPasswordForm',
  model: {
    prop: 'email',
    event: 'change'
  },
  props: {
    email: Object
  }
}
</script>
